import {ReactNode} from 'react';
import {Box, Paper, Stack, Typography} from '@mui/material';

interface Props {
    title: string;
    action?: ReactNode;
    children: ReactNode;
}

export const OrderFormSection = ({title, action, children}: Props) => (
    <Paper
        variant="outlined"
        sx={{
            p: {xs: 1.25, sm: 2},
            borderRadius: 3,
            borderColor: 'divider',
            backgroundImage: 'none',
        }}
    >
        <Stack direction="row" alignItems="center" justifyContent="space-between" spacing={1} sx={{mb: 1.5}}>
            <Typography variant="subtitle1" fontWeight={700}>{title}</Typography>
            {action && <Box flexShrink={0}>{action}</Box>}
        </Stack>
        {children}
    </Paper>
);
